import { FC } from 'react';
import { PanelBar as PanelBarKendo, PanelBarProps } from '@progress/kendo-react-layout';
import classNames from 'classnames/bind';

import styles from './PanelBar.module.scss';

const cx = classNames.bind(styles);

export const PanelBar: FC<PanelBarProps> = (props) => {
  return <PanelBarKendo {...props} className={cx('panelBar', props.className)} />;
};
